// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5491b2ce","849":"6cd63843","977":"9afe9fca"}[chunkId] + ".chunk.js";
};